import { z } from 'zod';
import { Id } from './primitives.js';
/**
 * An administrator corrects ONE price reading on a finished visit — the
 * "Koreksi Kunjungan" console surface.
 *
 * WHY THIS IS NOT THE FR-06 CORRECTION PATH. `SubmitCorrectionsRequest` is a
 * salesperson fixing their OWN open visit, anchored to a photo, gated
 * `visit:create`. This is an ADMIN fixing a reading on a visit that has already
 * CLOSED, gated `visit:write`, and it targets a `price_observations` row by id —
 * so it can reach a reading with no photo behind it (a hand entry, a price
 * carried from a previous visit) that the photo-anchored path never could.
 *
 * It CHANGES ONLY the number and the product it is filed under. The photograph
 * is evidence and never moves; a planogram score is read off geometry this
 * request does not carry, and is never touched.
 *
 * AT LEAST ONE FIELD MUST BE PRESENT. An edit that changes neither is a no-op
 * the server rejects rather than a correction row that moved nothing.
 */
export const VisitPriceEditRequest = z
    .object({
    /** The corrected price in whole rupiah. Omit to change only the product. */
    valueIdr: z.number().int().positive().optional(),
    /** The product this reading is really for. Omit to change only the price. */
    skuId: Id.optional(),
})
    .refine((body) => body.valueIdr !== undefined || body.skuId !== undefined, {
    message: 'tidak ada perubahan — isi harga baru atau produk baru',
});
//# sourceMappingURL=visit-price-edit.js.map